import {Injectable} from '@angular/core';
import {CrudConfig, CrudInteractionService, CrudService} from '@ngx-ivengi/crud';
import {RequestParams} from '@ngx-ivengi/crud';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {Building} from '../building/building.model';
import {Maintenance} from './maintenance.model';
import {ErrorMessage, NotificationService} from '@ngx-ivengi/notification';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/map';

@Injectable()
export class MaintenanceService extends CrudService<Maintenance> {
  public entityType = Maintenance;

  private statusFilterId: number = this.config.getFilterId();
  private maintenanceUpdate$: Subject<Maintenance[]> = new Subject<Maintenance[]>();

  constructor(
    config: CrudConfig,
    http: HttpClient,
    interactionService: CrudInteractionService,
    private notificationService: NotificationService
  ) {
    super(config, http, interactionService);
  }

  public getAllBuildings() {
    return this.http.get(`${this.getBaseUrl()}/building`).map((response: any[]) => {
      return response.map((itemData) => {
        const building = new Building();
        building.fromResponse(itemData);
        return building;
      });
    });
  }

  public getAllActive(): Observable<Maintenance[]> {

    const requestParams = new RequestParams();
    requestParams
      .addFilterParam({
        id: this.statusFilterId,
        key: 'Maintenance.status',
        operator: 'ne',
        value: 'ARCHIVE'
      })
      .pagination.limit = 0;

    return new Observable<Maintenance[]>((observer) => {
        super.getAll(requestParams).subscribe((maintenances: Maintenance[]) => {
          this.maintenanceUpdate$.next(maintenances);
          observer.next(maintenances);
        });
      }
    );
  }

  public fetch(): Observable<Maintenance[]> {
    return this.maintenanceUpdate$;
  }

  public renderMail(data): Observable<any> {
    return new Observable((observer) => {
      this.http.post(`${this.getBaseUrl()}/action/render-email`, data, {observe: 'response'}).subscribe(
        response => {
          observer.next(<any>response.body);
        },
        err => {
          this.notificationService.notify(new ErrorMessage().setData('maintenance.action.error'));
          observer.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/maintenance/maintenance.service.ts